import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=0ce76ab4&scoped=true&"
import script from "./Budgets.vue?vue&type=script&lang=js&"
export * from "./Budgets.vue?vue&type=script&lang=js&"
import style0 from "./Budgets.vue?vue&type=style&index=0&id=0ce76ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce76ab4",
  null
  
)

export default component.exports